import type {PropertyAdaptiveStyle, PropsAdaptiveStyle} from 'uikit'

export const adaptiveConfigMarginTop: PropertyAdaptiveStyle = {
  cssKey: 'marginTop',
  axis: 'height',
  params: [30, 10, 5, 2, 2, 2, 2],
}

export const adaptiveConfigImgWidth: PropertyAdaptiveStyle = {
  cssKey: 'width',
  axis: 'height',
  params: [200, 190, 180, 150, 150, 150, 150],
}

export const adaptiveConfigModal: PropsAdaptiveStyle = [
  {
    cssKey: 'width',
    axis: 'width',
    params: [746, 746, 540, 480, 390, 320, 320],
  },
]
